'use client';

import Script from 'next/script';
import type React from 'react';
import { useEffect } from 'react';

type ConsentStatusChangeEvent = Event & {
  detail?: Record<string, unknown>;
};

export default function CampaignClientScripts(): React.ReactElement {
  useEffect(() => {
    // Keep behaviour compatible with the legacy landingpage:
    // - fix anchor navigation after hydration
    // - persist tracking consent based on the Usercentrics event
    const hash = window.location.hash;
    if (hash.length > 0) {
      window.location.hash = '';
      window.location.hash = hash;
    }

    localStorage.setItem('trackingConsent', 'false');

    const handler = (event: Event) => {
      const e = event as ConsentStatusChangeEvent;
      const detail = e.detail;
      if (!detail || typeof detail !== 'object') return;

      let state = false;
      for (const [provider, status] of Object.entries(detail)) {
        if (provider === 'Google Analytics Statistics' && Boolean(status)) {
          state = true;
          break;
        }
      }
      localStorage.setItem('trackingConsent', String(state));
    };

    window.addEventListener('onConsentStatusChange', handler);
    return () => window.removeEventListener('onConsentStatusChange', handler);
  }, []);

  return (
    <>
      <Script src="//cdn-eu.dynamicyield.com/api/9876067/api_dynamic.js" strategy="afterInteractive" />
      <Script src="//cdn-eu.dynamicyield.com/api/9876067/api_static.js" strategy="afterInteractive" />
      <Script
        src="https://app.usercentrics.eu/browser-ui/latest/loader.js"
        id="usercentrics-cmp"
        data-settings-id="7wE46YhXz"
        data-avoid-prefetch-services=""
        strategy="afterInteractive"
      />
      <Script id="gtm" strategy="afterInteractive">
        {`
function reloadCustomerStatusCookie(){
  var linkElement = document.getElementById('customerStatusServerResource');
  if(!!linkElement){
    if(('' + linkElement.href).indexOf('?') === -1){
      linkElement.href += '?rnd=' + Math.random();
    } else {
      linkElement.href += '&rnd=' + Math.random();
    }
  }
}
function initGTM() {
  (function (w, d, s, l, i) { w[l] = w[l] || []; w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" }); var f = d.getElementsByTagName(s)[0], j = d.createElement(s), dl = l != "dataLayer" ? "&l=" + l : ""; j.async = true; j.src = "https://sgtm.swd-ag.de/gtm.js?id=" + i + dl; f.parentNode.insertBefore(j, f); })(window, document, "script", "dataLayer", "GTM-5FSVPSZ");
  reloadCustomerStatusCookie();
}
initGTM();
`}
      </Script>
    </>
  );
}
